export default `
  mutation addCardComment($workflowId: String!, $cardId: ID!, $input: CardCommentInput!) {
    addCardComment(workflowId: $workflowId, cardId: $cardId, input: $input) {
      workflowId
      cardId
      id
      author {
        id
        firstname
        lastname
        picture {
          url
          file {
            key
          }
        }
      }
      text
      dateCreated
      dateUpdated
      generatedByAi
    }
  }
`
